import { c as _c } from "react/compiler-runtime";
import BudgetCalculator from "@components/BudgetCalculator";
import { ComponentSectionsBudgetCalculator } from "@lib/generated/graphql";
import { FC } from "react";
interface BudgetCalculatorProps {
  data: ComponentSectionsBudgetCalculator;
}
const BudgetCalculatorSection: FC<BudgetCalculatorProps> = t0 => {
  const $ = _c(2);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = <div className="my-3xl grid grid-cols-12"><BudgetCalculator data={data} className="col-span-12 s:col-span-10 s:col-start-2 m:col-span-6 m:col-start-4" /></div>;
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BudgetCalculatorSection;